import { useCallback } from 'react';

import { useFormController } from '@dreryk/react-common';
import { FormContent } from '@dreryk/react-components';

import { CurrentUserEmailField, PasswordField } from '~libs.desktop.shared.fields';

import { translationKeys } from '../../translations';

import { AccountAuthorizationFormBean, AccountAuthorizationFormController } from './AccountAuthorizationForm.types';
import { StyledForm } from './AccountAuthorizationForm.styled';

type AccountAuthorizationFormRenderProps = Pick<AccountAuthorizationFormController, 'handleSubmit' | 'formState'> & {
   setIncorrectPersonalPasswordError: VoidFunction;
};

type AccountAuthorizationFormProps = {
   readonly children: (renderProps: AccountAuthorizationFormRenderProps) => JSX.Element;
};

export const AccountAuthorizationForm = (props: AccountAuthorizationFormProps): JSX.Element => {
   const { register, handleSubmit, setError, formState } = useFormController<AccountAuthorizationFormBean>({
      accountPassword: null,
   });

   const setIncorrectPersonalPasswordError = useCallback(() => {
      setError('accountPassword', {
         message: translationKeys.incorrectPassword,
      });
   }, [setError]);

   return (
      <>
         <StyledForm noValidate autoComplete={'off'}>
            <FormContent testId={'authentication'}>
               <CurrentUserEmailField controller={register('accountEmail')} label={translationKeys.email} />
               <PasswordField
                  controller={register('accountPassword', { required: true })}
                  label={translationKeys.accountPassword}
               />
            </FormContent>
         </StyledForm>
         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
            setIncorrectPersonalPasswordError: setIncorrectPersonalPasswordError,
         })}
      </>
   );
};
